"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityLatestGrid = exports.EntityLatestGridDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var client_1 = require("@apollo/client");
var entity_list_query_1 = require("../../utils/entity-list-query");
var lodash_1 = require("lodash");
var entity_grid_1 = require("./entity-grid");
var loader_1 = require("../elements/loader");
var use_entities_1 = require("../../hooks/use-entities");
exports.EntityLatestGridDefaultProps = {
  limit: 3
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(entity_grid_1.EntityGrid)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var EntityLatestGrid = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    limit = props.limit;
  var defn = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var entities = (0, use_entities_1.useEntities)();
  if (!defn) {
    return null;
  }
  var _a = (0, client_1.useQuery)((0, entity_list_query_1.entityListQuery)(defn, {
      entities: entities
    }), {
      variables: {
        limit: limit,
        orderBy: [{
          fieldName: 'created',
          desc: true
        }]
      }
    }),
    loading = _a.loading,
    data = _a.data;
  var results = (0, lodash_1.get)(data, "list".concat(defn.pluralTypeName, ".results"), []);
  if (loading) {
    return react_1.default.createElement(loader_1.Loader, null);
  }
  return react_1.default.createElement(My.Container, {
    entityTypeName: entityTypeName,
    items: results,
    className: className
  });
};
exports.EntityLatestGrid = EntityLatestGrid;
exports.EntityLatestGrid.defaultProps = exports.EntityLatestGridDefaultProps;
var templateObject_1, templateObject_2;